export default __webpack_public_path__ + "static/media/foieEtCoeur.93c49587.jpg";